// javascripts/utils/geoUtils.js

/**
 * 十進法の緯度経度を度分秒（DMS）に変換する関数
 * @param {number} decimal - 十進法の緯度または経度
 * @returns {string} 度分秒（DMS）形式の文字列
 */

export const toDMS = (decimal) => {
  const deg = Math.floor(Math.abs(decimal));
  const min = Math.floor((Math.abs(decimal) - deg) * 60);
  const sec = (Math.abs(decimal) - deg - min / 60) * 3600;
  const secInt = Math.floor(sec);
  const secDec = (sec - secInt).toFixed(1).substring(2);

  const minStr = min.toString().padStart(2, "0");
  const secIntStr = secInt.toString().padStart(2, "0");
  return `${deg}°${minStr}′${secIntStr}″.${secDec}`;
};

const EARTH_CIRCUMFERENCE = 40075017; // in meters
const TILE_SIZE = 256; // Google Maps tile size link: https://developers.google.com/maps/documentation/ios-sdk/tiles?hl=ja

/**
 * ズームレベルを現場の幅と地図の幅から推定する関数。
 * 現場の最大幅が格納されるズームレベルを返します。
 * @param {number} siteWidthMeters - 現場の幅（メートル単位）
 * @param {number} mapWidthPixels - 地図の幅（ピクセル単位）
 * @returns {number} 推定ズームレベル
 */
export const estimateZoomLevel = (siteWidthMeters: number, mapWidthPixels: number): number => {
  // 一回り大きい値にするため、1を引いています。
  const zoomLevel = Math.log2((EARTH_CIRCUMFERENCE / siteWidthMeters) * (mapWidthPixels / TILE_SIZE));
  return Math.min(Math.max(Math.floor(zoomLevel) - 2, 0), 21); // ズームレベルは0から21の範囲内である必要があります
};
